import React from 'react';
import { centeredMainGridClasses } from '@/styles/grid';
import { LogoEye } from 'components/src/svg';
import { Heading, Paragraph } from 'components/src/typography';
import Tab, { Tabs } from 'components/src/tab';
import InputForms from './InputForms';
import { ContactUsTab } from './Utils';

type Props = {
  showThankYouModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const TAB_ORDER: ContactUsTab[] = ['einstaklingar', 'fyrirtaeki'];
const TAB_LABELS: Record<ContactUsTab, string> = {
  einstaklingar: 'Einstaklingur',
  fyrirtaeki: 'Fyrirtæki',
};

const ContactUs = ({ showThankYouModal }: Props) => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const selectedTab = TAB_ORDER[selectedTabIndex];

  return (
    <div className={`${centeredMainGridClasses} py-100 md:py-128`}>
      <div className="col-span-5 mt-128 hidden pt-64 md:flex lg:w-full lg:justify-center">
        <LogoEye width={270} height={168} />
      </div>
      <div className="col-span-full grid gap-16 self-center lg:col-start-7">
        <Heading variant="xl">{'Hafa samband'}</Heading>
        <Paragraph variant="title-lg" classes="pb-24">
          {'Sendu okkur línu og við svörum um hæl.'}
        </Paragraph>
        <Tabs>
          {TAB_ORDER.map((tab, index) => (
            <Tab
              key={tab}
              index={index}
              buttonlayoutId="hafa-samband-tab"
              label={TAB_LABELS[tab]}
              selected={selectedTabIndex === index}
              onClick={setSelectedTabIndex}
            />
          ))}
        </Tabs>
        <InputForms selectedTab={selectedTab} showThankYouModal={showThankYouModal} />
      </div>
    </div>
  );
};

export default ContactUs;
